// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {InitializationTask} from "../../recording-dialogs/recorder-initialization-dialog/recorder-initialization-dialog.component";
import Enumerable from "linq";
import {SimUtilityService} from "@services";
import {slideInLeftOnEnterAnimation, zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";

export interface DialogData_InitializeJoinTrainingDialogInput extends MatDialogDataBaseInput {
	initializationTasks: InitializationTask[];
}

export interface DialogData_InitializeJoinTrainingDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-initialize-join-training-dialog",
	templateUrl: "./initialize-join-training-dialog.component.html",
	styleUrls: ["./initialize-join-training-dialog.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	standalone: false,
})
export class InitializeJoinTrainingDialogComponent extends BasicMaterialDialog<
	InitializeJoinTrainingDialogComponent,
	DialogData_InitializeJoinTrainingDialogInput,
	DialogData_InitializeJoinTrainingDialogOutput
> {
	public failed: boolean = false;

	constructor(_injector: Injector) {
		super(_injector);
	}

	async ngDoCheck() {
		const tasks = Enumerable.from(this.data.initializationTasks);
		const failed = tasks.any((task) => task.success == false);
		const success = !failed && tasks.all((task) => task.success);
		if (success) {
			await SimUtilityService.delay(500);
			this.close();
		} else if (failed) {
			await SimUtilityService.delay(500);
			this.failed = true;
		}
	}
}
